import React, { Ref } from 'react';
import clsx from 'clsx';
import TextareaAutosize from 'react-textarea-autosize';

import styles from './TextArea.module.scss';

type Props = {
  hasFixedSize?: boolean;
  fixedRows?: number;
  className?: string;
  error?: boolean;
  helperText?: string;
  errorText?: string;
} & Omit<React.TextareaHTMLAttributes<HTMLTextAreaElement>, 'height' | 'style'>;

export const TextArea = React.forwardRef(function TextArea(
  props: Props,
  ref: Ref<HTMLTextAreaElement>,
) {
  const {
    helperText,
    errorText,
    error,
    className,
    hasFixedSize,
    fixedRows,
    ...restProps
  } = props;
  return (
    <div>
      <TextareaAutosize
        {...restProps}
        data-error={error}
        ref={ref}
        className={clsx(styles.area, className)}
        maxRows={hasFixedSize ? (fixedRows ?? 1) : undefined}
        minRows={fixedRows}
      />
      {!!(helperText || errorText) && (
        <div data-error={error} className={styles.helperText}>
          {helperText || errorText}
        </div>
      )}
    </div>
  );
});
